export default __webpack_public_path__ + "static/media/img-1.df51b2d5.jpg";